import { useAuthStore } from '@/plugins/w/auth/store/auth.store'
import wAxios from '@/plugins/w/axios/models/axios'
import { useQuery } from '@tanstack/vue-query'

export const QUERY_KEY = 'hint-group'
export const QUERY_KEY_ALL = 'hint-group-all'
export const fetchFn = async (slug: string) => {
	return wAxios.get_auth(`v1/hint-groups/${slug}/hints`).catch((error) => Promise.reject(error.response || error))
}

export const fetchFnNew = async () => {
	return wAxios.get_auth(`v1/hints`).catch((error) => Promise.reject(error.response || error))
}

export const fetchQuery = (slug: string) => {
	return { slug }
}

export const useGetHintGroup = (slug: string) => useQuery({
	queryKey: [QUERY_KEY, { accessId: useAuthStore().getCurrentAccess?.id, slug }],
	queryFn: () => fetchFn(slug),
	select: (data) => data.data
})

export const useGetAllHintGroup = () => useQuery({
	queryKey: [QUERY_KEY_ALL],
	queryFn: () => fetchFnNew(),
	select: (data) => data.data,
	staleTime: Infinity,
	gcTime: Infinity,
	refetchOnMount: false
})
// Prerobit vsetky ne-tabulkove na toto
// Premenovat api-hook na nieco ze table-api-hook